import { z } from "zod";

const BrowseControlActivitiesSummarySchema = z.object({
  query: z.any(),
});

export default BrowseControlActivitiesSummarySchema;
